import {isDev, isSUT} from '../utils/env';

const isOverridable = isSUT() || isDev();

export const isFeatureEnabled = (key) => {
  const isEnabledByEnv = import.meta.env[key] === 'true';
  const isEnabledByStorage = sessionStorage.getItem(key) === 'true';

  return isOverridable ? isEnabledByStorage || isEnabledByEnv : isEnabledByEnv;
};

export const setFeatureFlagOnStorage = (key, value) => {
  sessionStorage.removeItem(key);
  if (!isOverridable) {
    return;
  }

  sessionStorage.setItem(key, `${!!value}`);
};
